import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SalesInsightsAPI from '../../../api/SalesInsightsAPI';

type Props = { timeRange: { start: string; end: string } };

function PendingPaymentsCard({ timeRange }: Props) {
  const { t } = useTranslation();
  const [amount, setAmount] = useState<number | null>(null);
  const [count, setCount] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await SalesInsightsAPI.getPaymentInstalments({
          startTime: timeRange.start,
          endTime: timeRange.end,
        });
        const payload = res.data;
        if (payload) {
          setAmount(payload.pendingAmount ?? 0);
          setCount(payload.pendingCount ?? 0);
        } else {
          setAmount(0);
          setCount(0);
        }
      } catch {
        setAmount(0);
        setCount(0);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [timeRange.start, timeRange.end]);

  if (loading) {
    return (
      <div className="space-y-1">
        <p className="text-sm text-muted-foreground">{t('global.loading') || 'Loading'}...</p>
      </div>
    );
  }

  const displayAmount =
    amount !== null && count !== null
      ? amount === 0 && count === 0
        ? '—'
        : amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      : '—';

  return (
    <div className="space-y-1">
      <p className="text-2xl font-bold text-foreground">{displayAmount}</p>
      <p className="text-sm text-muted-foreground">
        {amount === 0 && count === 0
          ? '—'
          : t('sales.insights.number_of_payments', { count: count ?? 0 })}
      </p>
    </div>
  );
}

export default PendingPaymentsCard;
